import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconClose = styled.img.attrs({
  src: "/assets/images/icon-close.png"
})`
  cursor: pointer;
  height: ${ICON_HEIGHT}px;
`;
IconClose.displayName = "IconClose";

export default IconClose;
